export default __webpack_public_path__ + "static/media/br.1fc5872b.svg";